import { Component, OnInit, Input } from '@angular/core'
import { OrderTrackingService } from '../../order-tracking.service'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { SAP_ASCTD_DOC_TYPES } from './associated-documents-types.model'
import { saveAs } from 'file-saver'
@Component({
  standalone: false,
  selector: 'vs-associated-documents',
  templateUrl: './associated-documents.component.html',
  styleUrls: ['./associated-documents.component.scss'],
})
export class AssociatedDocumentsComponent implements OnInit {
  fullDocumentsResponse: any
  viewAllDocuments: any = []
  @Input() orderNo: any
  fileExtension
  downloadLoader = []
  downloadAllLoader: boolean

  constructor(
    private orderTrackingService: OrderTrackingService,
    protected globalMessageService: GlobalMessageService
  ) {}

  ngOnInit(): void {
    this.fetchAllDocuments()
  }

  fetchAllDocuments() {
    this.orderTrackingService.getAllDocuments(this.orderNo).subscribe(
      (response) => {
        this.fullDocumentsResponse = response
        if (
          this.fullDocumentsResponse !== undefined &&
          this.fullDocumentsResponse !== null
        ) {
          this.arrangeDocuments()
        }
      },
      (error) => {
        this.globalMessageService.add(
          { key: 'orderTracking.issueWhileFetchingAssociatedDoc' },
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  arrangeDocuments() {
    let documentSet = []
    let documentNodes = [
      'invoices',
      'customInvoices',
      'deliveryNotes',
      'salesOrderAck',
      'purchaseOrders',
      'customerUploadedDocuments',
    ]

    for (let dn = 0; dn < documentNodes.length; dn++) {
      if (this.fullDocumentsResponse[documentNodes[dn]]) {
        for (
          let i = 0;
          i < this.fullDocumentsResponse[documentNodes[dn]].length;
          i++
        ) {
          if (
            this.fullDocumentsResponse[documentNodes[dn]][i].fileType == 'xls'
          ) {
            this.fileExtension = 'xlsx'
            documentSet.push({
              documentNumber:
                this.fullDocumentsResponse[documentNodes[dn]][i].docNumber,
              documentName:
                this.fullDocumentsResponse[documentNodes[dn]][i].fileName,
              documentType:
                this.fullDocumentsResponse[documentNodes[dn]][i].fileType,
              documentNamingType:
                this.fullDocumentsResponse[documentNodes[dn]][i].docType,
              documentExtesion: this.fileExtension,
            })
          } else {
            ;(this.fileExtension =
              this.fullDocumentsResponse[documentNodes[dn]][i].fileType),
              documentSet.push({
                documentNumber:
                  this.fullDocumentsResponse[documentNodes[dn]][i].docNumber,
                documentName:
                  this.fullDocumentsResponse[documentNodes[dn]][i].fileName,
                documentType:
                  this.fullDocumentsResponse[documentNodes[dn]][i].fileType,
                documentNamingType:
                  this.fullDocumentsResponse[documentNodes[dn]][i].docType,
                documentExtesion: this.fileExtension,
              })
          }
        }
      }
    }
    this.viewAllDocuments = documentSet
  }

  // checkDocumentNameType(documentNode) {
  //   let documentNameType;
  //   switch (documentNode) {
  //     case 'customInvoices':
  //       documentNameType = this.fullDocumentsResponse.customInvFileName;
  //       break;
  //     case 'deliveryNotes':
  //       documentNameType = this.fullDocumentsResponse.delNoteFileName;
  //       break;
  //     case 'invoices':
  //       documentNameType = this.fullDocumentsResponse.invFileName;
  //       break;
  //     case 'purchaseOrders':
  //       documentNameType = this.fullDocumentsResponse.poFileName;
  //       break;
  //     case 'salesOrderAck':
  //       documentNameType = this.fullDocumentsResponse.soaFileName;
  //       break;
  //   }
  //   return documentNameType;
  // }

  // checkDocumentType(documentNode) {
  //   let documentType;
  //   switch (documentNode) {
  //     case 'customInvoices':
  //       documentType = this.fullDocumentsResponse.customInvDocType;
  //       break;
  //     case 'deliveryNotes':
  //       documentType = this.fullDocumentsResponse.delNoteDocType;
  //       break;
  //     case 'invoices':
  //       documentType = this.fullDocumentsResponse.invDocType;
  //       break;
  //     case 'purchaseOrders':
  //       documentType = this.fullDocumentsResponse.poDocType;
  //       break;
  //     case 'salesOrderAck':
  //       documentType = this.fullDocumentsResponse.soaDocType;
  //       break;
  //   }
  //   return documentType;
  // }

  downloadAllFiles() {
    this.viewAllDocuments.forEach((document, index) => {
      this.downloadAllLoader = true
      this.downloadDocument(document, index)
    })
  }

  downloadDocument(document, index?) {
    this.downloadLoader[index] = true
    let docNumber = document.documentNumber
    let docType = document.documentNamingType
    let fileName = document.documentName
    let fileType = document.documentType

    this.orderTrackingService
      .downloadDocument(docNumber, docType, fileName, fileType)
      .subscribe(
        (res) => {
          this.downloadLoader[index] = false
          let count = 0
          this.downloadLoader.map((element, index) => {
            if (element === true) {
              count++
            }
          })
          if (count > 0 && this.downloadAllLoader === true) {
          } else {
            this.downloadAllLoader = false
          }
          if (res !== null && res !== undefined) {
            let fileName =
              document.documentNamingType + '_' + document.documentName
            if (fileType == 'pdf') {
              const blob = new Blob([res], { type: 'application/pdf' })
              const file = new File([blob], fileName + '.pdf', {
                type: 'application/pdf',
              })
              saveAs(file)
            } else if (fileType == 'doc' || fileType == 'docx') {
              const blob = new Blob([res], { type: 'application/msword' })
              const file = new File([blob], fileName + '.doc', {
                type: 'application/msword',
              })
              saveAs(file)
            } else if (fileType == 'jpg' || fileType == 'JPG') {
              const blob = new Blob([res], { type: 'application/jpeg' })
              const file = new File([blob], fileName + '.jpg', {
                type: 'application/jpeg',
              })
              saveAs(file)
            } else if (fileType == 'png' || fileType == 'PNG') {
              const blob = new Blob([res], { type: 'application/png' })
              const file = new File([blob], fileName + '.png', {
                type: 'application/png',
              })
              saveAs(file)
            } else if (fileType == 'xls' || fileType == 'xlsx') {
              const blob = new Blob([res], {
                type: 'application/vnd.ms-excel',
              })
              const file = new File([blob], fileName + '.xlsx', {
                type: 'application/vnd.ms-excel',
              })
              saveAs(file)
            }
          } else {
            this.displayDownloadError(document)
          }
        },
        (error) => {
          this.downloadAllLoader = false
          this.downloadLoader[index] = false
          this.displayDownloadError(document)
        }
      )
  }

  generateFileName(document) {
    return document.documentNamingType + '_' + document.documentName
  }

  displayDownloadError(document) {
    this.globalMessageService.add(
      { key: 'orderTracking.issueWhileDownloadingDoc' } +
        this.generateFileName(document),
      GlobalMessageType.MSG_TYPE_ERROR,
      5000
    )
    window.scrollTo(0, 0)
  }
}
